import { Link, useLocation, useNavigate } from 'react-router-dom';
import { ShoppingCart, Menu, X, User, LogOut, LayoutDashboard } from 'lucide-react';
import { useEffect, useState } from 'react';
import CartSheet from './CartSheet';
import Logo from './Logo';
import NotificationBell from './NotificationBell';
import { useAuth } from '../context/AuthContext';
import { NAV_LINKS } from '../mock';

export default function Navbar() {
  const location = useLocation();
  const navigate = useNavigate();
  const [cartOpen, setCartOpen] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);
  const [userMenu, setUserMenu] = useState(false);
  const { user, logout } = useAuth();

  useEffect(() => {
    const open = () => setCartOpen(true);
    window.addEventListener('cart:open', open);
    return () => window.removeEventListener('cart:open', open);
  }, []);

  const active = (href) => location.pathname === href;

  const handleLogout = () => { logout(); setUserMenu(false); navigate('/'); };

  const dashHref = user?.role === 'admin' ? '/admin' : user?.role === 'partner' ? '/partner/dashboard' : '/dashboard';

  return (
    <>
      <header className="sticky top-0 z-40 bg-cream/85 backdrop-blur-md border-b border-black/5">
        <div className="max-w-7xl mx-auto px-5 h-16 flex items-center justify-between">
          <Logo />

          <nav className="hidden lg:flex items-center gap-7">
            {NAV_LINKS.map((l) => (
              <Link
                key={l.href}
                to={l.href}
                className={`text-sm transition-colors ${active(l.href) ? 'text-navy font-semibold' : 'text-neutral-700 hover:text-navy'}`}
              >
                {l.label}
              </Link>
            ))}
          </nav>

          <div className="flex items-center gap-2">
            <button onClick={() => setCartOpen(true)} className="btn-ghost !py-1.5 !px-3 text-sm">
              <ShoppingCart size={15} /> <span className="hidden sm:inline">Cart</span>
            </button>

            {user && <NotificationBell />}

            {user ? (
              <div className="relative">
                <button onClick={() => setUserMenu((v) => !v)} className="btn-ghost !py-1.5 !px-3 text-sm">
                  <User size={15} /> <span className="hidden sm:inline">{user.name?.split(' ')[0] || 'Account'}</span>
                </button>
                {userMenu && (
                  <div className="absolute right-0 mt-2 w-52 card-soft shadow-xl py-2 z-50">
                    <div className="px-4 py-2 border-b">
                      <p className="text-sm font-semibold">{user.name}</p>
                      <p className="text-xs text-neutral-500">{user.email || user.phone}</p>
                    </div>
                    <Link to={dashHref} onClick={() => setUserMenu(false)} className="flex items-center gap-2 px-4 py-2 text-sm hover:bg-black/5"><LayoutDashboard size={14} /> Dashboard</Link>
                    <Link to="/profile" onClick={() => setUserMenu(false)} className="flex items-center gap-2 px-4 py-2 text-sm hover:bg-black/5"><User size={14} /> Profile</Link>
                    <button onClick={handleLogout} className="w-full flex items-center gap-2 px-4 py-2 text-sm hover:bg-black/5 text-red-600"><LogOut size={14} /> Logout</button>
                  </div>
                )}
              </div>
            ) : (
              <Link to="/login" className="btn-ghost !py-1.5 !px-3 text-sm hidden sm:inline-flex">Login</Link>
            )}

            <Link to="/shop" className="btn-primary !py-2 !px-4 text-sm hidden sm:inline-flex">Buy tag</Link>

            <button onClick={() => setMenuOpen((v) => !v)} className="lg:hidden p-2">
              {menuOpen ? <X size={18} /> : <Menu size={18} />}
            </button>
          </div>
        </div>

        {menuOpen && (
          <div className="lg:hidden border-t bg-white">
            <div className="max-w-7xl mx-auto px-5 py-4 flex flex-col gap-3">
              {NAV_LINKS.map((l) => (
                <Link key={l.href} to={l.href} onClick={() => setMenuOpen(false)} className="text-sm py-1.5">{l.label}</Link>
              ))}
              {!user && <Link to="/login" onClick={() => setMenuOpen(false)} className="text-sm py-1.5">Login</Link>}
              <Link to="/shop" onClick={() => setMenuOpen(false)} className="btn-primary justify-center mt-2">Buy tag</Link>
            </div>
          </div>
        )}
      </header>

      <CartSheet open={cartOpen} onClose={() => setCartOpen(false)} />
    </>
  );
}
